<template>
<div style="min-height:200px;">
  <el-row type="flex" justify="space-between" class="title-bar" >
    <w-perf-analysis-time-info :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataLoad" />
    <w-header-search-button @click="onClickSearchToolVisible"></w-header-search-button>
  </el-row>
  <el-table-wrapper border :data="tableList" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" ref="table" style="width:100%;" :pagination="true" :column-default="columnDefault">
    <template slot-scope="scope" slot="state-slot">
      <span :class="$style['table-column-state-success']" v-if="isStateFormatter(scope.row.STATUS)">정상</span>
      <span :class="$style['table-column-state-failure']" v-else>비정상</span>
    </template>
    <template slot="avilability-slot" slot-scope="scope">
      <el-progress v-if="scope.row.availability >= 0" :text-inside="true" :stroke-width="18" :percentage="getProgressValue(scope.row.availability)"></el-progress>
      <el-progress v-else :text-inside="true" :stroke-width="18" :percentage="0"></el-progress>
    </template>
  </el-table-wrapper>
</div>
</template>
<script>
import isEmpty from 'lodash/isEmpty';
import floor from 'lodash/floor';
import { columnDefault } from '@/constants/table';
import { analysisTimeType } from '@/constants/performance';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';

const stateFilters = [
  {
    text: '정상',
    value: '1',
  },
  {
    text: '비정상',
    value: '0',
  },
];

export default {
  name: 'WHardwareTable',
  components: {
    WPerfAnalysisTimeInfo,
  },
  props: {
    tableData: {
      type: Object,
    },
  },
  data() {
    return {
      analysisTimeType,
      columnDefault,
      tableList: null,
      checkDatetime: null,
      columns: [
        {
          prop: 'STATUS',
          label: '상태',
          headerAlign: 'center',
          sortable: true,
          showOverflowTooltip: true,
          filterMultiple: false,
          filters: stateFilters,
          filterMethod: this.filterState,
          scopedSlot: 'state-slot',
        },
        {
          prop: 'agentName',
          label: '에이전트 명',
          headerAlign: 'center',
          sortable: true,
          showOverflowTooltip: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'statusCode',
          label: '응답코드',
          headerAlign: 'center',
          sortable: true,
          showOverflowTooltip: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'availability',
          label: '가용률(%)',
          headerAlign: 'center',
          sortable: true,
          showOverflowTooltip: true,
          scopedSlot: 'avilability-slot',
        },
        {
          label: '응답시간(ms)',
          headerAlign: 'center',
          childColumns: [
            {
              prop: 'total',
              label: '전체',
              sortable: true,
              showOverflowTooltip: true,
              headerAlign: 'center',
              width: 100,
              formatter: this.getTableValueAfterCheckEmpty,
            },
            {
              prop: 'nameLookup',
              label: '네임서버',
              sortable: true,
              showOverflowTooltip: true,
              headerAlign: 'center',
              width: 100,
              formatter: this.getTableValueAfterCheckEmpty,
            },
            {
              prop: 'hostServerConn',
              label: '호스트연결',
              sortable: true,
              showOverflowTooltip: true,
              headerAlign: 'center',
              width: 100,
              formatter: this.getTableValueAfterCheckEmpty,
            },
            {
              prop: 'serviceWait',
              label: '서비스대기',
              sortable: true,
              showOverflowTooltip: true,
              headerAlign: 'center',
              width: 100,
              formatter: this.getTableValueAfterCheckEmpty,
            },
            {
              prop: 'fileTransfer',
              label: '파일전송',
              sortable: true,
              showOverflowTooltip: true,
              headerAlign: 'center',
              width: 100,
              formatter: this.getTableValueAfterCheckEmpty,
            },
            {
              prop: 'dbService',
              label: 'DB접근',
              sortable: true,
              showOverflowTooltip: true,
              headerAlign: 'center',
              width: 100,
              formatter: this.getTableValueAfterCheckEmpty,
            },
          ],
        },
      ],
      showSearchTool: false,
    };
  },
  watch: {
    tableData: {
      handler(tableData) {
        if (isEmpty(tableData)) {
          this.tableList = [];
          this.checkDatetime = null;
        } else {
          // this.tableList = isEmpty(tableData.snapshotDoc) ? [] : tableData.snapshotDoc;
          if (this.tableData.timeType === this.analysisTimeType.HIST.value) {
            this.tableList = this.tableData.snapshotDoc;
          } else {
            this.tableList = this.tableData.currentList;
          }
          this.checkDatetime = this.tableData.timestamp;
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * [changeDataFlag 검색기능 show]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    onClickSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    /**
     * [status 상태 컬럼 필터링]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @param  {[type]} row   [description]
     * @return {[type]}       [description]
     */
    filterState(value, row) {
      if (value === '0') {
        return row.STATUS !== '1';
      }
      return row.STATUS === '1';
    },
    /**
     * [isStateFormatter 상태 컬럼 포맷]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    isStateFormatter(value) {
      if (value === '1') {
        return true;
      }
      return false;
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    getProgressValue(value) {
      if (getValueAfterCheckEmpty(value) !== EMPTY_TEXT) {
        return floor(value, 2);
      }
      return 0; // EMPTY_TEXT로 설정 시 String 에러 출력
    },
    onTimeTypeChange(value) {
      this.$emit('time-type-change', value);
    },
    onCurrentDataLoad() {
      this.$emit('reload');
    },
  },
};
</script>
<style module>
.table-column-state-success {
  color: #5a9ee4;
}

.table-column-state-failure {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/e2e/components/AgentStatusTable.vue